import * as React from 'react'
export const SvgPause = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} {...props}>
    <path d="M17 20h-2V4h2v16zm-8 0H7V4h2v16z" fill={props.fill || '#333'} />
  </svg>
)
export default SvgPause
